import React from "react";
import { Pill } from "../../../common/DataList";

// Deux issues acquises en vert, un blocage en orange, et deux issues closes
// sans envoi qui ne se confondent pas (ST1-2209) : « Rien à déclarer » en gris
// (l'EP n'a pas sanctionné, rien à corriger) ; « Non transmise à France
// Travail » en rouge (la sanction existe, FT ne peut pas la recevoir, la Caf
// la traite à la main dans NIMS). Pastilles du kit DataList.
const STATUT_TONES = {
  BLOQUEE: "warn",
  DECLAREE: "ok",
  RADIATION_DEMANDEE: "ok",
  NON_DECLARABLE: "muted",
  NON_TRANSMISSIBLE: "ko",
};

/**
 * Pastille de statut d'une sanction déclarée par la CAF à France Travail.
 * Le libellé affiché vient toujours de `statutLabel` (fourni par l'API).
 */
const StatutDeclarationBadge = ({ statut, statutLabel }) => (
  <Pill tone={STATUT_TONES[statut] || "muted"}>{statutLabel}</Pill>
);

export default StatutDeclarationBadge;
